if (!customElements.get('kk-wickelplatz-pdp')) {
  customElements.define('kk-wickelplatz-pdp', class KKWickelplatzPDP extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      const dataNode = this.querySelector('[data-kk-wickelplatz-pdp-data]');
      try {
        this.data = JSON.parse(dataNode ? dataNode.textContent : '{}');
      } catch (error) {
        this.data = {};
      }
      this.attachments = Array.isArray(this.data.attachments) ? this.data.attachments : [];
      this.shelves = Array.isArray(this.data.shelves) ? this.data.shelves : [];
      this.form = document.getElementById(this.dataset.productFormId);
      this.variantRoot = (this.form && this.form.closest('.shopify-section')) || this.form;
      this.variantInput = this.form && this.form.querySelector('input[name="id"]');
      this.quantityInput = this.form && this.form.querySelector('input[name="quantity"]');
      this.addButton = this.querySelector('[data-kk-pdp-add]');
      this.status = this.querySelector('[data-kk-pdp-status]');
      this.selectedPad = null;
      this.selectedShelf = null;
      this.lastVariantId = '';
      this.selectedFamilyKey = '';
      this.showAllPads = false;

      this.padGrid = this.querySelector('[data-kk-pdp-pad-grid]');
      this.shelfGrid = this.querySelector('[data-kk-pdp-shelf-grid]');
      this.padFeature = this.querySelector('[data-kk-pdp-pad-feature]');
      this.padSwatches = this.querySelector('[data-kk-pdp-swatches]');
      this.showAllButton = this.querySelector('[data-kk-pdp-show-all]');
      if (!this.variantInput || !this.padGrid || !this.shelfGrid || !this.addButton || !this.attachments.length) {
        this.hidden = true;
        return;
      }

      this.currentAttachment = this.findAttachment(this.currentVariantId());
      if (!this.currentAttachment) {
        this.hidden = true;
        return;
      }
      this.lastVariantId = this.currentAttachment ? this.currentAttachment.id : '';
      this.renderAttachment();
      this.renderFamilies();
      this.renderPads();
      this.renderShelves();
      this.updateSummary();
      this.updateButton();

      this.addEventListener('click', (event) => {
        const padButton = event.target.closest('[data-kk-pdp-pad]');
        const familyButton = event.target.closest('[data-kk-pdp-family]');
        const shelfButton = event.target.closest('[data-kk-pdp-shelf]');
        const clearShelf = event.target.closest('[data-kk-pdp-clear-shelf]');
        const showAllPads = event.target.closest('[data-kk-pdp-show-all]');
        if (padButton && this.contains(padButton)) this.choosePad(padButton.dataset.kkPdpPad);
        if (familyButton && this.contains(familyButton)) this.chooseFamily(familyButton.dataset.kkPdpFamily);
        if (shelfButton && this.contains(shelfButton)) this.chooseShelf(shelfButton.dataset.kkPdpShelf);
        if (clearShelf && this.contains(clearShelf)) this.chooseShelf('');
        if (showAllPads && this.contains(showAllPads)) this.toggleAllPads();
        if (event.target.closest('[data-kk-pdp-add]')) this.addSelection();
      });

      this._formChangeHandler = () => this.scheduleVariantSync();
      this._formClickHandler = (event) => {
        if (event.target.closest('[data-product-option], .product-variants, variant-picker')) this.scheduleVariantSync();
      };
      this.variantRoot.addEventListener('change', this._formChangeHandler);
      this.variantRoot.addEventListener('input', this._formChangeHandler);
      this.variantRoot.addEventListener('click', this._formClickHandler);
      this._variantEvents = ['variant:changed', 'product:variant-change', 'product:variant:change'];
      this._variantHandler = () => this.scheduleVariantSync();
      this._variantEvents.forEach((name) => window.addEventListener(name, this._variantHandler));
      if (!this.hideOriginalPurchaseActions()) {
        this.hidden = true;
        return;
      }
      this.hideReplacedProductBlocks();
      this.hidden = false;
      this.dataset.ready = 'true';
    }

    disconnectedCallback() {
      (this._variantEvents || []).forEach((name) => window.removeEventListener(name, this._variantHandler));
      if (this.variantRoot) {
        this.variantRoot.removeEventListener('change', this._formChangeHandler);
        this.variantRoot.removeEventListener('input', this._formChangeHandler);
        this.variantRoot.removeEventListener('click', this._formClickHandler);
      }
      window.clearTimeout(this._variantSyncTimer);
    }

    hideReplacedProductBlocks() {
      const productPage = (this.form && this.form.closest('product-page')) || this.closest('product-page');
      const productText = this.closest('.product-text') || (productPage && productPage.querySelector('.product-text'));
      const legacyBuilder = productPage && productPage.querySelector('.wickelplatz-builder');
      if (legacyBuilder) {
        legacyBuilder.hidden = true;
        legacyBuilder.style.setProperty('display', 'none', 'important');
      }
      if (!productText) return;
      productText.querySelectorAll('.textile-collection-banner').forEach((banner) => {
        const wrapper = banner.closest('.product-custom-liquid');
        if (wrapper) wrapper.hidden = true;
      });
      productText.querySelectorAll('product-recommendations').forEach((recommendations) => {
        if ((recommendations.dataset.url || '').includes('intent=complementary')) {
          recommendations.hidden = true;
          recommendations.style.setProperty('display', 'none', 'important');
        }
      });
    }

    hideOriginalPurchaseActions() {
      const originalAddButton = this.form && this.form.querySelector('[data-main-product-add-to-cart]');
      if (!originalAddButton) return false;
      let jumpButton = this.form.querySelector('[data-kk-pdp-jump]');
      if (!jumpButton) {
        jumpButton = document.createElement('a');
        jumpButton.className = 'kk-finder__button kk-wickelplatz-pdp__jump';
        jumpButton.dataset.kkPdpJump = '';
        jumpButton.href = '#kk-wickelplatz-pdp';
        jumpButton.textContent = this.dataset.textJumpToBuilder || '';
        originalAddButton.parentNode.insertBefore(jumpButton, originalAddButton);
      }
      originalAddButton.hidden = true;
      originalAddButton.style.setProperty('display', 'none', 'important');
      const paymentButton = this.form.querySelector('.shopify-payment-button');
      if (paymentButton) {
        paymentButton.hidden = true;
        paymentButton.style.setProperty('display', 'none', 'important');
      }
      return true;
    }

    showOriginalPurchaseActions() {
      const originalAddButton = this.form && this.form.querySelector('[data-main-product-add-to-cart]');
      if (originalAddButton) {
        originalAddButton.hidden = false;
        originalAddButton.style.removeProperty('display');
      }
      const paymentButton = this.form && this.form.querySelector('.shopify-payment-button');
      if (paymentButton) {
        paymentButton.hidden = false;
        paymentButton.style.removeProperty('display');
      }
      const jumpButton = this.form && this.form.querySelector('[data-kk-pdp-jump]');
      if (jumpButton) jumpButton.remove();
      const productPage = this.form && this.form.closest('product-page');
      const legacyBuilder = productPage && productPage.querySelector('.wickelplatz-builder');
      if (legacyBuilder) {
        legacyBuilder.hidden = false;
        legacyBuilder.style.removeProperty('display');
      }
    }

    findAttachment(id) {
      const normalized = String(id || '');
      return this.attachments.find((attachment) => attachment.id === normalized) || null;
    }

    currentVariantId() {
      const selectedVariant = this.variantRoot && this.variantRoot.querySelector('input[data-variant-id]:checked');
      return String((selectedVariant && selectedVariant.dataset.variantId) || (this.variantInput && this.variantInput.value) || '');
    }

    scheduleVariantSync() {
      window.clearTimeout(this._variantSyncTimer);
      this._variantSyncTimer = window.setTimeout(() => this.syncVariant(), 0);
    }

    syncVariant() {
      const nextId = this.currentVariantId();
      if (nextId === this.lastVariantId) {
        this.updateSummary();
        this.updateButton();
        return;
      }
      const previousSize = this.currentAttachment && this.currentAttachment.sizeKey;
      this.currentAttachment = this.findAttachment(nextId);
      this.lastVariantId = nextId;
      if (!this.currentAttachment) {
        this.hidden = true;
        this.showOriginalPurchaseActions();
        this.updateSummary();
        this.updateButton();
        return;
      }
      this.hidden = false;
      this.hideOriginalPurchaseActions();
      this.hideReplacedProductBlocks();
      if (!this.currentAttachment || this.currentAttachment.sizeKey !== previousSize) {
        this.selectedPad = null;
        this.selectedFamilyKey = '';
      } else if (this.selectedPad && !this.currentAttachment.mats.some((pad) => pad.id === this.selectedPad.id)) {
        this.selectedPad = null;
      }
      this.renderAttachment();
      this.renderFamilies();
      this.renderPads();
      this.updateSummary();
      this.updateButton();
      if (this.status) this.status.textContent = this.dataset.textSelectionChanged;
    }

    familyList() {
      const mats = this.currentAttachment ? this.currentAttachment.mats : [];
      const families = [];
      const seen = new Set();
      mats.forEach((pad) => {
        const key = pad.familyKey || pad.familyLabel || pad.title;
        if (!seen.has(key)) {
          seen.add(key);
          families.push({ key, label: pad.familyLabel || pad.title });
        }
      });
      return families;
    }

    renderFamilies() {
      const container = this.querySelector('[data-kk-pdp-families]');
      if (!container) return;
      const activeKey = document.activeElement && document.activeElement.dataset.kkPdpFamily;
      container.replaceChildren();
      this.familyList().forEach((family) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kk-finder__pill';
        button.dataset.kkPdpFamily = family.key;
        button.textContent = family.label;
        button.setAttribute('aria-pressed', String(this.selectedFamilyKey === family.key));
        container.appendChild(button);
      });
      if (activeKey) {
        const replacement = Array.from(container.querySelectorAll('[data-kk-pdp-family]')).find((button) => button.dataset.kkPdpFamily === activeKey);
        if (replacement) replacement.focus({ preventScroll: true });
      }
    }

    formatMoney(cents) {
      const currency = this.dataset.currency || 'EUR';
      const locale = this.dataset.locale || document.documentElement.lang || 'de-DE';
      try {
        const digits = new Intl.NumberFormat(locale, { style: 'currency', currency }).resolvedOptions().maximumFractionDigits;
        return new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: digits, maximumFractionDigits: digits }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return this.currentAttachment ? this.currentAttachment.priceLabel : '';
      }
    }

    currentQuantity() {
      return Math.max(1, parseInt(this.quantityInput && this.quantityInput.value, 10) || 1);
    }

    renderAttachment() {
      const card = this.querySelector('[data-kk-pdp-attachment]');
      const title = this.querySelector('[data-kk-pdp-attachment-title]');
      const variant = this.querySelector('[data-kk-pdp-attachment-variant]');
      const image = this.querySelector('[data-kk-pdp-attachment-image]');
      if (!this.currentAttachment) {
        if (card) card.setAttribute('aria-disabled', 'true');
        if (title) title.textContent = '';
        if (variant) variant.textContent = '';
        if (image) image.hidden = true;
        return;
      }
      if (card) card.removeAttribute('aria-disabled');
      if (title) title.textContent = this.currentAttachment.title;
      if (variant) variant.textContent = [this.dataset.textAttachmentLabel, this.currentAttachment.variant, this.currentAttachment.size].filter(Boolean).join(' · ');
      const price = this.querySelector('[data-kk-pdp-attachment-price]');
      if (price) price.textContent = this.currentAttachment.priceLabel;
      if (image) {
        image.src = this.currentAttachment.image || '';
        image.alt = this.currentAttachment.imageAlt || this.currentAttachment.title;
        image.hidden = !this.currentAttachment.image;
      }
    }

    renderPads() {
      if (!this.padGrid || !this.padFeature || !this.padSwatches || !this.showAllButton) return;
      const activeId = document.activeElement && document.activeElement.dataset.kkPdpPad;
      const showAllHadFocus = document.activeElement === this.showAllButton;
      this.padFeature.replaceChildren();
      this.padSwatches.replaceChildren();
      this.padGrid.replaceChildren();
      const pads = this.currentAttachment
        ? this.currentAttachment.mats.filter((pad) => pad.familyKey === this.selectedFamilyKey)
        : [];
      if (!pads.length) {
        const empty = document.createElement('p');
        empty.className = 'kk-wickelplatz-pdp__none';
        empty.textContent = this.selectedFamilyKey ? this.dataset.textPadNone : this.dataset.textChooseFamily;
        this.padFeature.appendChild(empty);
        this.showAllButton.hidden = true;
        this.padGrid.hidden = true;
        return;
      }
      const featuredPad = (this.selectedPad && pads.find((pad) => pad.id === this.selectedPad.id)) || pads[0];
      const makePadCard = (pad, featured = false) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `kk-finder__card kk-wickelplatz-pdp__choice${featured ? ' kk-wickelplatz-pdp__featured-choice' : ''}`;
        button.dataset.kkPdpPad = pad.id;
        button.setAttribute('aria-pressed', String(Boolean(this.selectedPad && this.selectedPad.id === pad.id)));
        button.setAttribute('aria-label', [pad.familyLabel, pad.design, pad.size, pad.priceLabel].filter(Boolean).join(', '));
        button.setAttribute('data-design-gid', pad.stoffdesignGid || '');
        const media = document.createElement('span');
        media.className = 'kk-finder__media';
        if (pad.image) {
          const image = document.createElement('img');
          image.className = 'kk-finder__image';
          image.src = pad.image;
          image.alt = pad.imageAlt || '';
          image.loading = 'lazy';
          image.width = 720;
          image.height = 610;
          media.appendChild(image);
        }
        const body = document.createElement('span');
        body.className = 'kk-finder__body';
        if (pad.design) {
          const design = document.createElement('span');
          design.textContent = pad.design;
          body.appendChild(design);
        }
        const size = document.createElement('span');
        size.textContent = pad.size;
        body.appendChild(size);
        const price = document.createElement('strong');
        price.className = 'kk-wickelplatz-pdp__price';
        price.textContent = pad.priceLabel;
        body.appendChild(price);
        const action = document.createElement('span');
        action.className = 'kk-finder__button kk-wickelplatz-pdp__button-label';
        action.textContent = this.selectedPad && this.selectedPad.id === pad.id ? this.dataset.textPadSelected : this.dataset.textPadChoose;
        body.appendChild(action);
        button.append(media, body);
        return button;
      };
      this.padFeature.appendChild(makePadCard(featuredPad, true));
      pads.forEach((pad) => {
        const swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'kk-wickelplatz-pdp__swatch-choice';
        swatch.dataset.kkPdpPad = pad.id;
        swatch.setAttribute('aria-pressed', String(Boolean(this.selectedPad && this.selectedPad.id === pad.id)));
        swatch.setAttribute('aria-label', [pad.design, pad.size, pad.priceLabel].filter(Boolean).join(', '));
        swatch.title = pad.design || pad.familyLabel;
        if (pad.swatch) {
          const swatchImage = document.createElement('img');
          swatchImage.src = pad.swatch;
          swatchImage.alt = '';
          swatchImage.loading = 'lazy';
          swatch.appendChild(swatchImage);
        }
        this.padSwatches.appendChild(swatch);
        this.padGrid.appendChild(makePadCard(pad));
      });
      this.showAllButton.hidden = pads.length < 2;
      this.showAllButton.setAttribute('aria-expanded', String(this.showAllPads));
      this.showAllButton.textContent = this.showAllPads ? this.dataset.textHideAllDesigns : this.dataset.textShowAllDesigns;
      this.padGrid.hidden = !this.showAllPads;
      if (activeId) {
        const replacement = Array.from(this.querySelectorAll('[data-kk-pdp-pad]')).find((button) => button.dataset.kkPdpPad === activeId);
        if (replacement) replacement.focus({ preventScroll: true });
      }
      if (showAllHadFocus && !this.showAllButton.hidden) this.showAllButton.focus({ preventScroll: true });
    }

    toggleAllPads() {
      this.showAllPads = !this.showAllPads;
      this.renderPads();
    }

    renderShelves() {
      if (!this.shelfGrid) return;
      const activeElement = document.activeElement;
      const activeShelfId = activeElement && activeElement.dataset.kkPdpShelf;
      this.shelfGrid.replaceChildren();
      const clear = this.querySelector('[data-kk-pdp-clear-shelf]');
      if (clear) clear.setAttribute('aria-pressed', String(!this.selectedShelf));
      if (!this.shelves.length) {
        const none = document.createElement('p');
        none.className = 'kk-wickelplatz-pdp__none';
        none.textContent = this.dataset.textShelfNone;
        this.shelfGrid.appendChild(none);
        return;
      }
      this.shelves.forEach((shelf) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kk-finder__card kk-wickelplatz-pdp__choice';
        button.dataset.kkPdpShelf = shelf.id;
        button.setAttribute('aria-pressed', String(Boolean(this.selectedShelf && this.selectedShelf.id === shelf.id)));
        button.setAttribute('aria-label', [shelf.title, shelf.variant, shelf.priceLabel].filter(Boolean).join(', '));
        const media = document.createElement('span');
        media.className = 'kk-finder__media';
        if (shelf.image) {
          const image = document.createElement('img');
          image.className = 'kk-finder__image';
          image.src = shelf.image;
          image.alt = shelf.imageAlt || '';
          image.loading = 'lazy';
          image.width = 480;
          image.height = 400;
          media.appendChild(image);
        }
        const body = document.createElement('span');
        body.className = 'kk-finder__body';
        const title = document.createElement('strong');
        title.className = 'kk-wickelplatz-pdp__item-title';
        title.textContent = shelf.title;
        body.appendChild(title);
        if (shelf.variant) {
          const variant = document.createElement('span');
          variant.textContent = shelf.variant;
          body.appendChild(variant);
        }
        const price = document.createElement('strong');
        price.className = 'kk-wickelplatz-pdp__price';
        price.textContent = shelf.priceLabel;
        body.appendChild(price);
        const action = document.createElement('span');
        action.className = 'kk-finder__button kk-wickelplatz-pdp__button-label';
        action.textContent = this.selectedShelf && this.selectedShelf.id === shelf.id ? this.dataset.textShelfSelected : this.dataset.textShelfChoose;
        body.appendChild(action);
        button.append(media, body);
        this.shelfGrid.appendChild(button);
      });
      if (activeShelfId) {
        const replacement = Array.from(this.shelfGrid.querySelectorAll('[data-kk-pdp-shelf]')).find((button) => button.dataset.kkPdpShelf === activeShelfId);
        if (replacement) replacement.focus({ preventScroll: true });
      }
    }

    chooseFamily(key) {
      this.selectedFamilyKey = String(key);
      this.showAllPads = false;
      if (this.selectedPad && this.selectedPad.familyKey !== this.selectedFamilyKey) this.selectedPad = null;
      this.renderFamilies();
      this.renderPads();
      this.updateSummary();
      this.updateButton();
      if (this.status) this.status.textContent = '';
    }

    choosePad(id) {
      if (!this.currentAttachment) return;
      const candidate = this.currentAttachment.mats.find((pad) => pad.id === String(id));
      if (!candidate) return;
      this.selectedPad = this.selectedPad && this.selectedPad.id === candidate.id ? null : candidate;
      this.renderPads();
      this.updateSummary();
      this.updateButton();
      if (this.status) this.status.textContent = '';
    }

    chooseShelf(id) {
      const candidate = this.shelves.find((shelf) => shelf.id === String(id));
      this.selectedShelf = candidate && (!this.selectedShelf || this.selectedShelf.id !== candidate.id) ? candidate : null;
      this.renderShelves();
      this.updateSummary();
      this.updateButton();
      if (this.status) this.status.textContent = '';
    }

    updateSummary() {
      const quantity = this.currentQuantity();
      const baseCents = this.currentAttachment ? Number(this.currentAttachment.priceCents) * quantity : 0;
      const padCents = this.selectedPad ? Number(this.selectedPad.priceCents) : 0;
      const shelfCents = this.selectedShelf ? Number(this.selectedShelf.priceCents) : 0;
      const lineBase = this.querySelector('[data-kk-pdp-line-attachment]');
      const linePad = this.querySelector('[data-kk-pdp-line-pad]');
      const lineShelf = this.querySelector('[data-kk-pdp-line-shelf]');
      const lineBasePrice = this.querySelector('[data-kk-pdp-line-attachment-price]');
      const linePadPrice = this.querySelector('[data-kk-pdp-line-pad-price]');
      const lineShelfPrice = this.querySelector('[data-kk-pdp-line-shelf-price]');
      if (lineBase) lineBase.textContent = this.currentAttachment ? `${this.currentAttachment.title}${this.currentAttachment.variant ? ` · ${this.currentAttachment.variant}` : ''} · ${quantity} ×` : this.dataset.textSelectVariant;
      if (lineBasePrice) lineBasePrice.textContent = this.currentAttachment ? this.formatMoney(baseCents) : '';
      if (linePad) linePad.textContent = this.selectedPad ? `${this.selectedPad.design || this.selectedPad.familyLabel} · ${this.selectedPad.size} · 1 ×` : this.dataset.textPadNone;
      if (linePadPrice) linePadPrice.textContent = this.selectedPad ? this.selectedPad.priceLabel : '';
      if (lineShelf) lineShelf.textContent = this.selectedShelf ? `${this.selectedShelf.title} · 1 ×` : this.dataset.textShelfNone;
      if (lineShelfPrice) lineShelfPrice.textContent = this.selectedShelf ? this.selectedShelf.priceLabel : '';
      const total = this.querySelector('[data-kk-pdp-total]');
      if (total) total.textContent = this.formatMoney(baseCents + padCents + shelfCents);
    }

    updateButton() {
      const validVariant = Boolean(this.currentAttachment && this.attachments.some((item) => item.id === this.currentAttachment.id));
      const validPad = !this.selectedPad || Boolean(this.currentAttachment && this.currentAttachment.mats.some((item) => item.id === this.selectedPad.id));
      const validShelf = !this.selectedShelf || this.shelves.some((item) => item.id === this.selectedShelf.id);
      this.addButton.disabled = this.busy || !validVariant || !validPad || !validShelf;
    }

    async addSelection() {
      if (this.busy) return;
      const variantId = this.currentVariantId();
      const attachment = this.findAttachment(variantId);
      const validPad = !this.selectedPad || (attachment && attachment.mats.some((item) => item.id === this.selectedPad.id));
      const validShelf = !this.selectedShelf || this.shelves.some((item) => item.id === this.selectedShelf.id);
      if (!attachment || !validPad || !validShelf) {
        this.currentAttachment = attachment;
        if (!validPad) this.selectedPad = null;
        if (!validShelf) this.selectedShelf = null;
        this.renderAttachment();
        this.renderPads();
        this.renderShelves();
        this.updateSummary();
        this.updateButton();
        if (this.status) this.status.textContent = this.dataset.textSelectionChanged;
        return;
      }
      const items = [{ id: attachment.id, quantity: this.currentQuantity() }];
      const properties = {};
      if (this.form) {
        this.form.querySelectorAll('[name^="properties["]').forEach((input) => {
          if (!input.name || input.disabled || input.type === 'file') return;
          if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
          if (input.value !== '') properties[input.name.replace(/^properties\[|\]$/g, '')] = input.value;
        });
      }
      if (Object.keys(properties).length) items[0].properties = properties;
      const sellingPlan = this.form && this.form.querySelector('[name="selling_plan"]');
      if (sellingPlan && sellingPlan.value) items[0].selling_plan = sellingPlan.value;
      if (this.selectedPad) items.push({ id: this.selectedPad.id, quantity: 1 });
      if (this.selectedShelf) items.push({ id: this.selectedShelf.id, quantity: 1 });
      const cartAddUrl = this.dataset.cartAddUrl;
      if (!cartAddUrl) {
        if (this.status) this.status.textContent = this.dataset.textCartError;
        return;
      }
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.updateButton();
      if (this.status) this.status.textContent = this.dataset.textAdding;
      try {
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || result.status === 422) throw new Error(result.description || result.message || this.dataset.textCartError);
        if (typeof window.refreshCart === 'function') {
          window.refreshCart(true);
        } else {
          window.location.href = this.dataset.cartUrl || '/cart';
          return;
        }
        const cartForm = document.getElementById('AjaxCartForm');
        if (cartForm) cartForm.dispatchEvent(new Event('cart-updated'));
        if (window.KROWN && KROWN.functions) {
          KROWN.functions.eventDispatcher('krown:cart:add', { variantId: attachment.id, source: 'kk-wickelplatz-pdp' });
          if (typeof KROWN.functions.dispatchStandardEvent === 'function') {
            KROWN.functions.dispatchStandardEvent('CartLinesUpdateEvent', document, {
              action: 'add', context: 'product', lines: items.map((item) => ({ merchandiseId: item.id, quantity: item.quantity })),
              promise: Promise.resolve({ cart: null })
            });
          }
        }
        if (this.status) this.status.textContent = this.dataset.textAdded;
        const screenReader = document.getElementById('screen-reader-info');
        if (screenReader) {
          screenReader.textContent = this.dataset.textAdded;
          window.setTimeout(() => { screenReader.textContent = ''; }, 1500);
        }
      } catch (error) {
        if (this.status) this.status.textContent = error && error.message ? error.message : this.dataset.textCartError;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.updateButton();
      }
    }
  });
}
